<template>
    <div class="editor-container">
        <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
        <!--<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">-->
        <!-- Main Menu -->
        <SOPEditorMenu v-if="editor"
                       :editor="editor"
                       @open="$emit('OpenButton')"
                       @save="$emit('SaveButton')"
                       @share="$emit('OpenShareMenuButton')"
                       @view-as-checklist="OpenAsChecklist()"
                       @view-as-slideshow="OpenAsSlideshow()"
                       @assign="$emit('OpenAssignMenuButton')"
                       @assign-role="$emit('OpenAssignToRoleMenuButton')"
                       @add-space="$emit('OpenAddToSpaceMenuButton')"
                       @properties="$emit('OpenPropertiesMenuButton')"
                       @clear-all="$emit('ClearAll')"
                       @delete="$emit('DeletOnboardingButton')"
                       @open-html-edit="(html) => OpenHTMLEditMenu(html, 'HTML')"
                       @import-file="ImportFile()"
                       @export-for-tcvelik="ExportForTCVelik()"
                       @export-to-pptx="ExportToPPTX()"
                       @export-sop-format="ExportSOPFormat()"
                       @open-intent-menu="OpenIntentMenu()"
                       @open-review-menu="OpenOnboardingReviewMenu"
                       @open-complete-sop-menu="OpenCompleteSOPMenu"
                       @open-cadence-menu="OpenCadenceMenu"
                       @generate-preview-link="$emit('GeneratePreviewLink')" />

        <!-- Main Toolbar -->
        <MainToolbar v-if="editor"
                     :editor="editor"
                     @add-line-above="AddLineAbove"
                     @add-line-below="AddLineBellow"
                     @open-link-menu="OpenLinkMenu"
                     @open-image-menu="OpenImageMenu"
                     @add-manual-step="AddManualStep"
                     @add-custom-html="insertCustomHTML"
                     @open-st-list="OpenStepTemplatesList"
                     @open-html-edit="(html) => OpenHTMLEditMenu(html, 'HTML')" />

        <!-- Popups -->
        <ImageEditorPopup :is-active.sync="isImageEditorActive"
                          :image="CurrentZoomImage"
                          @state-changed="HasImageChanges"
                          @image-save="ImageSaved" />

        <AdvancedPropertiesPopup :is-active.sync="IsInHTMLEditorMode"
                                 :editor-mode="editorMode"
                                 :prop-value="monacoValue"
                                 :code-value="monacoCodeValue"
                                 @copy-prop="CopyLink"
                                 @copy-code="CopyLink"
                                 @save-html="SaveHTML"
                                 @save-metadata="SaveMetadata"
                                 @save-code-step="SaveCodeStepData" />

        <CodeEditorPopup :is-active.sync="IsInCodeStepMode"
                         :codeValue="stepCodeValue"
                         @save-code-step="SaveCodeStepData" />

        <FreeHtmlEditorPopup :is-active.sync="IsInFreeHtmlEditorMode"
                         :htmlValue="freeHtmlValue"
                         @save-free-html="SaveFreeHtmlChanges" />

        <StepTemplateSavePopup :active.sync="IsInStepEditorMode" @step-template-saved="closeStepTemplateSavePopup" :isActive="IsInStepEditorMode" :rawHtml="rawHtml" :imagePreview="previewUrl"></StepTemplateSavePopup>

        <StepTemplatesList @use-template="UseTemplate"  :isActive.sync="InStepListMode" ></StepTemplatesList>

          <ImageUploadPopup :is-active.sync="InAddImageMode"
                            @upload-image="uploadImage"
                            @url-upload="AddImage" />
          <vs-popup title="Onboarding reviewers" fullscreen v-if="IsInOnboardingScheduleMode" :active.sync="IsInOnboardingScheduleMode">
            <OnboardingScheduleComponent v-if="IsInOnboardingScheduleMode" :is-active.sync="IsInOnboardingScheduleMode" :onboardingId="onboardingId" :type="1" />
          </vs-popup>

        <vs-popup title="Complete SOP assignments" fullscreen v-if="IsInCompleteSOPMode" :active.sync="IsInCompleteSOPMode">
          <OnboardingScheduleComponent v-if="IsInCompleteSOPMode" :is-active.sync="IsInCompleteSOPMode" :onboardingId="onboardingId" :type="2" />
        </vs-popup>

        <vs-popup title="Assign SOP Step" v-if="IsInAssignSOPMode" :active.sync="IsInAssignSOPMode">
          <div class="assign-sop-form">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input 
                  v-model="assignSOPData.sopId" 
                  label="SOP ID" 
                  placeholder="Enter SOP ID"
                  class="mb-4" />
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input 
                  v-model="assignSOPData.assignTo" 
                  label="Assign To" 
                  placeholder="Enter email or user identifier"
                  class="mb-4" />
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input 
                  v-model="assignSOPData.assignFor" 
                  label="Assign For" 
                  placeholder="Enter purpose or reason"
                  class="mb-4" />
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button 
                  color="primary" 
                  @click="SaveAssignSOPStep"
                  :disabled="!assignSOPData.sopId || !assignSOPData.assignTo || !assignSOPData.assignFor">
                  Create Step
                </vs-button>
                <vs-button 
                  color="danger" 
                  type="border" 
                  @click="IsInAssignSOPMode = false"
                  class="ml-2">
                  Cancel
                </vs-button>
              </div>
            </div>
          </div>
        </vs-popup>

        <vs-popup title="Form Capture Step" v-if="IsInFormCaptureMode" :active.sync="IsInFormCaptureMode">
          <div class="form-capture-form">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input 
                  v-model="formCaptureData.formId" 
                  label="Form ID" 
                  placeholder="Enter Form ID"
                  class="mb-4" />
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button 
                  color="primary" 
                  @click="SaveFormCaptureStep"
                  :disabled="!formCaptureData.formId">
                  Create Step
                </vs-button>
                <vs-button 
                  color="danger" 
                  type="border" 
                  @click="IsInFormCaptureMode = false"
                  class="ml-2">
                  Cancel
                </vs-button>
              </div>
            </div>
          </div>
        </vs-popup>

        <vs-popup title="Form Properties" v-if="IsInFormPropertiesMode" :active.sync="IsInFormPropertiesMode">
          <div class="form-properties-form">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-select 
                  v-model="formPropertiesData.formId" 
                  label="Select Form"
                  placeholder="Choose a form"
                  class="mb-4">
                  <vs-select-item 
                    v-for="form in availableForms" 
                    :key="form.id"
                    :value="form.id"
                    :text="`${form.title} (ID: ${form.id})`" />
                </vs-select>
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button 
                  color="primary" 
                  @click="SaveFormPropertiesStep"
                  :disabled="!formPropertiesData.formId">
                  Update Properties
                </vs-button>
                <vs-button 
                  color="danger" 
                  type="border" 
                  @click="IsInFormPropertiesMode = false"
                  class="ml-2">
                  Cancel
                </vs-button>
              </div>
            </div>
          </div>
        </vs-popup>

        <vs-popup title="SOP Properties" v-if="IsInAssignSOPPropertiesMode" :active.sync="IsInAssignSOPPropertiesMode" fullscreen>
          <div class="assign-sop-properties-form">
            <div class="vx-row">
              <div class="vx-col w-full">
                <h3 class="text-lg font-semibold mb-4">Assign SOP Properties</h3>
                
                <!-- SOP Selection -->
                <div class="form-field mb-4">
                  <label class="field-label">SOP</label>
                  <div class="sop-selection">
                    <div v-if="!assignSOPPropertiesData.selectedSOP" class="no-sop-selected">
                      <span class="no-sop-text">No SOP selected</span>
                      <a href="#" @click.prevent="openSOPSelector" class="change-link">Change</a>
                    </div>
                    <div v-else class="sop-selected">
                      <div class="sop-info">
                        <h4 class="sop-title">{{ assignSOPPropertiesData.selectedSOP.name }}</h4>
                        <p class="sop-description">{{ assignSOPPropertiesData.selectedSOP.description || 'No description available' }}</p>
                      </div>
                      <a href="#" @click.prevent="openSOPSelector" class="change-link">Change</a>
                    </div>
                  </div>
                </div>

                <!-- User Selection -->
                <div class="form-field mb-4">
                  <label class="field-label">Assign To</label>
                  <vs-select 
                    v-model="assignSOPPropertiesData.userId" 
                    label="Select User"
                    placeholder="Choose a user"
                    class="field-input">
                    <vs-select-item 
                      v-for="user in availableUsers" 
                      :key="user.id"
                      :value="user.id"
                      :text="`${user.firstName || ''} ${user.lastName || ''} (${user.email})`" />
                  </vs-select>
                  <div v-if="availableUsers.length === 0" class="text-center text-gray-500">
                    No users available
                  </div>
                  <div v-else class="text-sm text-gray-600">
                    Found {{ availableUsers.length }} user(s)
                  </div>
                </div>

                <!-- Due Date -->
                <div class="form-field mb-4">
                  <label class="field-label">Due Date</label>
                  
                  <!-- Date Type Selection -->
                  <div class="date-type-selection mb-3">
                    <label class="radio-option">
                      <input 
                        type="radio" 
                        v-model="assignSOPPropertiesData.dateType" 
                        value="absolute" 
                        name="dateType">
                      <span>Absolute Date</span>
                    </label>
                    <label class="radio-option">
                      <input 
                        type="radio" 
                        v-model="assignSOPPropertiesData.dateType" 
                        value="relative" 
                        name="dateType">
                      <span>Relative Date</span>
                    </label>
                  </div>
                  
                  <!-- Absolute Date Input -->
                  <vs-input 
                    v-if="assignSOPPropertiesData.dateType === 'absolute'"
                    v-model="assignSOPPropertiesData.dueDate"
                    type="date"
                    label="Due Date"
                    placeholder="Select due date"
                    class="field-input" />
                  
                  <!-- Relative Date Input -->
                  <div v-if="assignSOPPropertiesData.dateType === 'relative'" class="relative-date-input">
                    <div class="vx-row">
                      <div class="vx-col w-1/3">
                        <vs-input 
                          v-model="assignSOPPropertiesData.relativeDays"
                          type="number"
                          label="Days"
                          placeholder="5"
                          class="field-input" />
                      </div>
                      <div class="vx-col w-1/3">
                        <span class="relative-text">days after</span>
                      </div>
                      <div class="vx-col w-1/3">
                        <vs-select 
                          v-model="assignSOPPropertiesData.relativeEvent"
                          label="Event"
                          class="field-input">
                          <vs-select-item 
                            v-for="field in availableDateFields" 
                            :key="field.value"
                            :value="field.value" 
                            :text="field.text" />
                        </vs-select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Allow User to Change Values -->
                <div class="form-field mb-4">
                  <div class="checkbox-field">
                    <vs-checkbox 
                      v-model="assignSOPPropertiesData.allowUserToChangeValues">
                      Allow user to change values
                    </vs-checkbox>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button 
                  color="primary" 
                  @click="SaveAssignSOPPropertiesStep"
                  :disabled="!isAssignSOPPropertiesFormValid">
                  Update Properties
                </vs-button>
                <vs-button 
                  color="danger" 
                  type="border" 
                  @click="IsInAssignSOPPropertiesMode = false"
                  class="ml-2">
                  Cancel
                </vs-button>
              </div>
            </div>
          </div>
        </vs-popup>

        <!-- SOP Selector Modal -->
        <vs-popup title="Select SOP" :active.sync="showSOPSelector" fullscreen>
          <div class="sop-selector-content">
            <div v-if="availableSOPs.length > 0" class="sop-list-container">
              <div class="sop-list-header mb-4">
                <h3 class="text-lg font-semibold">Available SOPs</h3>
                <p class="text-gray-600">Select an SOP to assign</p>
              </div>

              <div class="sop-table-container">
                <vs-table class="sop-table" :data="availableSOPs" pagination max-items="10" search>
                  <template slot="thead">
                    <vs-th sort-key="id">ID</vs-th>
                    <vs-th sort-key="name">Title</vs-th>
                    <vs-th sort-key="description">Description</vs-th>
                    <vs-th>Actions</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="tr.id">
                        <div class="sop-id">{{ tr.id }}</div>
                      </vs-td>
                      
                      <vs-td :data="tr.name">
                        <div class="sop-name">
                          <strong>{{ tr.name }}</strong>
                        </div>
                      </vs-td>
                      
                      <vs-td :data="tr.description">
                        <div class="sop-description">
                          {{ tr.description || 'No description available' }}
                        </div>
                      </vs-td>
                      
                      <vs-td>
                        <vs-button 
                          @click="selectSOP(tr)"
                          color="primary" 
                          size="small">
                          Select
                        </vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            
            <div v-else class="empty-sops">
              <div class="text-center py-12 text-gray-500">
                <i class="fas fa-file-alt text-4xl mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">No SOPs available</h3>
                <p class="text-gray-600">There are no SOPs available for assignment.</p>
              </div>
            </div>

            <div class="modal-actions">
              <vs-button @click="closeSOPSelector" color="warning" type="border">
                Cancel
              </vs-button>
            </div>
          </div>
        </vs-popup>

        <GenericProgressPopup :active="genericProgressActive"
                              :current-step="genericCurrentStep"
                              :total-steps="genericTotalSteps"
                              @close="genericProgressActive = false" />

          <IntentForm :properties="properties" :is-active.sync="InIntentMenu" v-if="InIntentMenu" @save-intent="SaveIntent" @ask-ai="AskAiForIntent"></IntentForm>


          <CameraStepScreen v-if="IsInCameraStepMode"
                            :editor="editor"
                            @close-camera-step-screen="CloseCameraStepScreen" />


          <LinkPopup :is-active.sync="InAddLinkMode"
                     @add-link="handleAddLink" />

          <!-- Editor Content -->
          <div class="editor-content">
            <editor-content :editor="editor" />
          </div>

          <!-- Input for uploading TCVelik Onboarding Export -->
          <input v-on:change="ReadExportFile($event)" ref="import" type="file" id="tvoeFileInput" accept=".tvoe" style="display: none;" />
  </div>
</template>

<script>

  import { Editor, EditorContent, FloatingMenu } from "@tiptap/vue-2";
  import StarterKit from '@tiptap/starter-kit'
  import pptxgen from "pptxgenjs";
  import * as monaco from 'monaco-editor';
  import Table from '@tiptap/extension-table'
  import TableCell from '@tiptap/extension-table-cell'
  import TableHeader from '@tiptap/extension-table-header'
  import TableRow from '@tiptap/extension-table-row'
  import Link from '@tiptap/extension-link'
  import stepUtility from '@/utils/StepUtility.js'
  import Image from '@tiptap/extension-image'
  import Strike from '@tiptap/extension-strike'
  import Italic from '@tiptap/extension-italic'
  import Code from '@tiptap/extension-code'

  import Collaboration from '@tiptap/extension-collaboration'
  import CollaborationCursor from '@tiptap/extension-collaboration-cursor'
  import BubbleMenu from '@tiptap/extension-bubble-menu'
  // import Placeholder from '@tiptap/extension-placeholder'
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import OnboardingScheduleComponent from '@/views/components/extra-components/onboarding-schedule/OnboardingScheduleComponent.vue';

  import FormattingToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/FormattingToolbox.vue';
  import TableToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/TableToolbox.vue';
  import ActionsToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/ActionsToolbox.vue';
  import LinkToolbox from '@/views/components/atoms/tiptap/Predefined/Toolboxes/LinkToolbox.vue';
  import ChromeNodeview from '@/views/components/extra-components/editors/js/ChromeNodeView.js';
  import DisableEnter from '@/views/components/atoms/tiptap/Extensions/DisableEnter.js';
  import { FreeHtmlElement } from '@/views/components/atoms/tiptap/Extensions/FreeHTMLElement.js';
  import CameraStepScreen from '@/views/components/atoms/tiptap/Screens/CameraStepScreen.vue';
  import { TcvTableMenu } from '@/views/components/atoms/tiptap/Extensions/TcvTableMenu.js';
  import DisableBackspace from '@/views/components/atoms/tiptap/Extensions/DisableBackspace.js';
  import MonacoEditor from '@/views/components/extra-components/editors/MonacoEditor.vue';
  import TableInsertButton from "@/views/components/atoms/tiptap/Predefined/Buttons/Table/TableInsertButton.vue";
  import { AIMenuExtension } from '@/views/components/extra-components/editors/js/AIMenuExtension.js';
  import StepTemplateSavePopup from '@/views/components/extra-components/step-template/StepTemplateSavePopup.vue';
  import StepTemplatesList from '@/views/components/extra-components/step-template/StepTemplatesList.vue';
  import html2canvas from 'html2canvas';
  import IntentForm from '@/views/custom_forms/IntentForm.vue';
  import { DividerMenuExtension } from '@/views/components/atoms/tiptap/Extensions/DividerMenuExtension.js';

  import GenericProgressPopup from '@/views/components/extra-components/generic-progress/GenericProgressPopup.vue';

  import SignalRProvider from '@/views/components/extra-components/editors/providers/SignalRProvider.js';
  import * as Y from 'yjs'

  import { EventBus } from '@/eventBus/eventBus';
  import TCVelikExportImportService from '@/services/TCVelikExportImportService.js';

  import ImageEditorPopup from './popups/ImageEditorPopup.vue'
  import './TipTapChrome.scss'
  import AdvancedPropertiesPopup from './popups/AdvancedPropertiesPopup.vue'
  import CodeEditorPopup from './popups/CodeEditorPopup.vue'
  import FreeHtmlEditorPopup from './popups/FreeHtmlEditorPopup.vue'
  import ImageUploadPopup from './popups/ImageUploadPopup.vue'
  import LinkPopup from './popups/LinkPopup.vue'
  import SOPEditorMenu from './menus/SOPEditorMenu.vue'
  import MainToolbar from './toolbars/MainToolbar.vue'

  const CustomTableCell = TableCell.extend({
    addAttributes() {
      return {
        ...this.parent?.(),

        backgroundColor: {
          default: null,
          parseHTML: element => element.getAttribute('data-background-color'),
          renderHTML: attributes => {
            return {
              'data-background-color': attributes.backgroundColor,
              style: `background-color: ${attributes.backgroundColor}`,
            }
          },
        },
      }
    },
  })

  export default {
    name: 'TipTapChrome',
    props: {
      value: {
        type: String,
        default: '',
      },
      language: {
        type: String,
        default: 'html', // Default language for syntax highlighting
      },

    },
    components: {
      EditorContent,
      MonacoEditor,
      FormattingToolbox,
      Collaboration,
      CollaborationCursor,
      TableToolbox,
      CameraStepScreen,
      Link,
      Italic,
      OnboardingScheduleComponent,
      Strike,
      ActionsToolbox,
      LinkToolbox,
      FloatingMenu,
      ImageEditorPopup,
      TableInsertButton,
      AdvancedPropertiesPopup,
      ImageUploadPopup,
      LinkPopup,
      IntentForm,
      SOPEditorMenu,
      MainToolbar,
      GenericProgressPopup,
      CodeEditorPopup,
      FreeHtmlEditorPopup,
      StepTemplateSavePopup,
      StepTemplatesList
    },

    props: {
      value: {
        type: String,
        default: "",
      },
      title: {
        type: String,
        default: "",
      },
      onboardingId: {
        type: Number,
        default: 0
      },
      description: {
        type: String,
        default: "",
      },
      properties: {
        type: String,
        default: "",
      },
      editable: {
        type: Boolean,
        default: false
      },
      HideEditorToolBar: {
        type: Boolean,
        default: false
      },
      IsRecording: {
        type: Boolean,
        default: false
      },
      DiscoveredArtefacts: null,
      ItemsForThisUrl: null
    },

    data() {
      return {
        editor: null,
        ShowMenu: false,
        AddingStep: false,
        IsRecordingState: false,
        CurrentZoomImage: null,
        IsImageChanged: false,
        InIntentMenu: false,
        IsInFreeHtmlEditorMode: false,
        IsInOnboardingScheduleMode: false,
        IsInCompleteSOPMode: false,
        IsInCameraStepMode: false,
        IsInAssignSOPMode: false,
        IsInFormCaptureMode: false,
        isImageEditorActive: false,

        //Free HTML Editor
        IsInHTMLEditorMode: false,
        freeHtmlValue: "",
        freeHtmlElement: {},
        //

        //Step Template Code Save
        IsInStepEditorMode: false,
        previewUrl: "",
        rawHtml: "",

        InStepListMode:false,

        InAddImageMode: false,
        IsInCodeStepMode: false,
        InAddLinkMode: false,
        CurrentImgDOM: null,
        stepCodeValue: "",
        monacoValue: null,
        monacoCodeValue: null,
        assignSOPData: {
          sopId: '',
          assignTo: '',
          assignFor: ''
        },
        formCaptureData: {
          formId: ''
        },
        IsInFormPropertiesMode: false,
        formPropertiesData: {
          formId: ''
        },
        availableForms: [],
        IsInAssignSOPPropertiesMode: false,
        assignSOPPropertiesData: {
          sopId: '',
          userId: '',
          dueDate: null,
          selectedSOP: null,
          allowUserToChangeValues: false,
          dateType: 'absolute',
          relativeDays: 5,
          relativeEvent: 'sop-completion'
        },
        availableDateFields: [],
        availableSOPs: [],
        availableUsers: [],
        showSOPSelector: false,
        link_url: "",
        link_text: "",
        imageUrl: null,
        imageUpload: null,
        editorMode: "",
        stepNode: null,
        activeTab: 0,

        genericProgressActive: false,
        genericCurrentStep: 0,
        genericTotalSteps: 0,
        genericType: "",
        pendingImagePosition: null
      };
    },

    computed: {
      isAssignSOPPropertiesFormValid() {
        const isValid = this.assignSOPPropertiesData.userId && 
                       this.assignSOPPropertiesData.selectedSOP &&
                       ((this.assignSOPPropertiesData.dateType === 'absolute' && this.assignSOPPropertiesData.dueDate) ||
                        (this.assignSOPPropertiesData.dateType === 'relative' && this.assignSOPPropertiesData.relativeDays));
        return isValid;
      }
    },

    watch: {
      activeTab(newValue) {
        if (newValue == 1) {
          this.ExtractMetadata(this.$refs.monacoEditor.getValue())
        }
      },
      monacoValue(newValue) {
        this.ExtractMetadata(newValue)
      },
      value(newValue) {
        var instance = this;
        if (newValue !== instance.editor.getHTML()) {
          instance.editor.commands.setContent(newValue);

          instance.$nextTick(function () {
            window.requestAnimationFrame(function () {
              document.querySelectorAll("[data-node-view-content] img").forEach(img => {

                img.dataset["url"] = img.src;

                img.removeEventListener("mouseover", instance.ImageEditorIcon);
                img.addEventListener("mouseover", instance.ImageEditorIcon);

                img.removeEventListener("mouseout", instance.HideImageEditorIcon);
                img.addEventListener("mouseout", instance.HideImageEditorIcon);

                img.removeEventListener("mouseout", instance.HideImageEditorIcon);

                img.addEventListener("click", instance.StepImageEdit);
              })
            });
          });
        }
      },
      editable(newValue) {
        this.editor.setEditable(newValue);
      }
    },

    methods: {
      ImageEditorIcon(which) {
      },

      OpenLinkMenu() {
        this.InAddLinkMode = true;
        this.isImageEditorActive = false;
        this.InAddImageMode = false;
      },

      OpenImageMenu() {
        this.InAddImageMode = true;
        this.isImageEditorActive = false;
        this.CurrentZoomImage = null;
      },


        OpenAsChecklist() {
            if (this.onboardingId == 0) {
                this.$vs.notify({
                    title: this.$t('PleaseOpenAnOnboarding'),
                    color: 'warning',
                    iconPack: 'feather',
                    position: "top-center",
                    icon: "icon-check-circle",
                });
                return;
            }
          const route = this.$router.resolve({ path: '/pages/pdf-view', query: { oid: this.onboardingId } });
          window.open(route.href, '_blank')
      },

        OpenAsSlideshow() {
            if (this.onboardingId == 0) {
                this.$vs.notify({
                    title: this.$t('PleaseOpenAnOnboarding'),
                    color: 'warning',
                    iconPack: 'feather',
                    position: "top-center",
                    icon: "icon-check-circle",
                });
                return;
            }
          const route = this.$router.resolve({ path: '/pages/pdf-view', query: { oid: this.onboardingId, mode:"slideshow" } });
          window.open(route.href, '_blank')
      },

      OpenCameraStepMenu() {
        this.IsInCameraStepMode = true;
      },
      OpenIntentMenu() {
        this.InIntentMenu = true
      },
      CloseCameraStepScreen() {
        this.IsInCameraStepMode = false;
      },

      OpenHTMLEditMenu(value, editorMode) {
        const editorContent = this.editor ? this.editor.getHTML() : value
        this.monacoValue = editorContent
        this.editorMode = editorMode
        this.IsInHTMLEditorMode = true
      },

      OpenCodeStepEditor(value) {
        this.stepCodeValue = value
        this.IsInCodeStepMode = true
      },

      OpenFreeHtmlEditor(data) {
        this.freeHtmlElement = data.id
        this.freeHtmlValue = data.element
        this.IsInFreeHtmlEditorMode = true;
      },

      closeStepTemplateSavePopup() {
        this.previewUrl = "";
        this.rawHtml = ""
        this.IsInStepEditorMode = false;
      },

      async OpenStepTemplateSave(element) {
        const canvas = await html2canvas(element);
        this.previewUrl = canvas.toDataURL('image/png');
        this.rawHtml = element.innerHTML
        this.IsInStepEditorMode = true;
      },

      OpenStepTemplatesList() {
        this.InStepListMode = true
      },

      UseTemplate(html) {
        this.InStepListMode = false
        this.insertCustomHTML(html)
      },


      OpenOnboardingReviewMenu() {
        this.IsInOnboardingScheduleMode = true
      },
      OpenCompleteSOPMenu() {
        this.IsInCompleteSOPMode = true
      },
      OpenAssignSOPMenu() {
        this.IsInAssignSOPMode = true
      },
      OpenFormCaptureMenu() {
        this.IsInFormCaptureMode = true
      },
      SaveAssignSOPStep() {
        // Create metadata JSON with the assignment data
        const metadata = JSON.stringify({
          sopId: this.assignSOPData.sopId,
          assignTo: this.assignSOPData.assignTo,
          assignFor: this.assignSOPData.assignFor
        });

        // Create the step HTML with metadata
        const id = Math.random();
        const stepHtml = `<div data-type="draggable-item" data-temp-step-id="${id}" data-subtype="assign-sop">
          <p><strong><i class="fas fa-users text-purple-600 mr-2"></i>Assign SOP</strong></p>
          <p>SOP ID: ${this.assignSOPData.sopId}<br>
          Assign To: ${this.assignSOPData.assignTo}<br>
          Assign For: ${this.assignSOPData.assignFor}</p>
          <p>${metadata}</p>
        </div>`;

        // Insert the step into the editor
        this.editor.chain()
          .insertContent(stepHtml)
          .focus("end")
          .run();

        // Reset form data
        this.assignSOPData = {
          sopId: '',
          assignTo: '',
          assignFor: ''
        };

        // Close the popup
        this.IsInAssignSOPMode = false;

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');

        this.$vs.notify({
          title: 'Success',
          text: 'Assign SOP step created successfully',
          color: 'success'
        });
      },
      SaveFormCaptureStep() {
        // Create metadata JSON with the form capture data
        const metadata = JSON.stringify({
          formId: this.formCaptureData.formId
        });

        // Create the step HTML with metadata
        const id = Math.random();
        const stepHtml = `<div data-type="draggable-item" data-temp-step-id="${id}" data-subtype="form-capture">
          <p><strong><i class="fas fa-clipboard-list text-orange-600 mr-2"></i>Request Information</strong></p>
          <p>Form ID: ${this.formCaptureData.formId}</p>
          <p>${metadata}</p>
        </div>`;

        // Insert the step into the editor
        this.editor.chain()
          .insertContent(stepHtml)
          .focus("end")
          .run();

        // Reset form data
        this.formCaptureData = {
          formId: ''
        };

        // Close the popup
        this.IsInFormCaptureMode = false;

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');

        this.$vs.notify({
          title: 'Success',
          text: 'Form Capture step created successfully',
          color: 'success'
        });
      },
      OpenFormPropertiesEditor(formId) {
        this.formPropertiesData.formId = formId;
        this.loadAvailableForms();
        this.IsInFormPropertiesMode = true;
      },
      async loadAvailableForms() {
        try {
          const query = `
            query {
              forms {
                id
                title
                formMetadata
                createdAt
                updatedAt
              }
            }
          `;

          const response = await TCVelikClient.PostRelative('/api/graphql', {
            query: query
          });

          if (response && response.data && response.data.data && response.data.data.forms) {
            this.availableForms = response.data.data.forms;
          }
        } catch (error) {
          console.error('Error loading forms:', error);
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to load forms',
            color: 'danger'
          });
        }
      },
      SaveFormPropertiesStep() {
        if (!this.formPropertiesData.formId) {
          this.$vs.notify({
            title: 'Validation Error',
            text: 'Please select a form',
            color: 'danger'
          });
          return;
        }

        // Update the metadata in the step
        const metadata = JSON.stringify({
          formId: this.formPropertiesData.formId
        });
        
        // Find the form title for display
        const selectedForm = this.availableForms.find(f => f.id == this.formPropertiesData.formId);
        const formTitle = selectedForm ? selectedForm.title : 'Unknown Form';
        
        // Update the step content
        const stepContent = this.stepNode.querySelector('.content');
        if (stepContent) {
          const titleElement = stepContent.querySelector('p:first-child');
          const formIdElement = stepContent.querySelector('p:nth-child(2)');
          const metadataElement = stepContent.querySelector('p:nth-child(3)');
          
          if (titleElement) {
            titleElement.innerHTML = '<strong>Request Information</strong>';
          }
          if (formIdElement) {
            formIdElement.innerHTML = `Form: ${formTitle} (ID: ${this.formPropertiesData.formId})`;
          }
          if (metadataElement) {
            metadataElement.innerHTML = metadata;
          }
        }

        // Update the editor content
        this.editor.commands.setContent(this.editor.getHTML());

        // Reset form data
        this.formPropertiesData = {
          formId: ''
        };

        // Close the popup
        this.IsInFormPropertiesMode = false;

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');

        this.$vs.notify({
          title: 'Success',
          text: 'Form properties updated successfully',
          color: 'success'
        });
      },
      async OpenAssignSOPPropertiesEditor(sopId, properties = null) {
        // Initialize with default values
        this.assignSOPPropertiesData = {
          sopId: sopId,
          userId: '',
          dueDate: null,
          selectedSOP: null,
          allowUserToChangeValues: false,
          dateType: 'absolute',
          relativeDays: 5,
          relativeEvent: 'sop-completion'
        };

        // Parse and load saved properties if available
        if (properties) {
          try {
            const json = JSON.parse(properties);
            console.log('Loading SOP properties:', json);
            
            // Load basic properties
            if (json.userId) {
              this.assignSOPPropertiesData.userId = json.userId;
            }
            if (json.dueDate) {
              this.assignSOPPropertiesData.dueDate = json.dueDate;
            }
            if (json.allowUserToChangeValues !== undefined) {
              this.assignSOPPropertiesData.allowUserToChangeValues = json.allowUserToChangeValues;
            }
            
            // Load date type and relative date properties
            if (json.dateType) {
              this.assignSOPPropertiesData.dateType = json.dateType;
            }
            if (json.relativeDays) {
              this.assignSOPPropertiesData.relativeDays = json.relativeDays;
            }
            if (json.relativeEvent) {
              this.assignSOPPropertiesData.relativeEvent = json.relativeEvent;
            }
            
            // Load selected SOP info
            if (json.selectedSOP) {
              this.assignSOPPropertiesData.selectedSOP = json.selectedSOP;
            }
          } catch (error) {
            console.error('Error parsing SOP properties:', error);
          }
        }

        // Extract date fields from forms in current SOP
        await this.extractDateFieldsFromCurrentSOP();

        this.loadAvailableSOPs();
        this.loadAvailableUsers();
        this.IsInAssignSOPPropertiesMode = true;
      },
      async extractDateFieldsFromCurrentSOP() {
        try {
          // Get current editor content
          const editorContent = this.editor ? this.editor.getHTML() : '';
          
          // Parse HTML to find form-capture steps
          const parser = new DOMParser();
          const doc = parser.parseFromString(editorContent, 'text/html');
          const formCaptureSteps = doc.querySelectorAll('[data-subtype="form-capture"]');
          
          const dateFields = [];
          
          // Process each form-capture step
          for (const step of formCaptureSteps) {
            const metadataElement = step.querySelector('p:nth-child(3)');
            if (metadataElement) {
              try {
                const metadata = JSON.parse(metadataElement.textContent);
                if (metadata.formId) {
                  // Load form details to get field information
                  const formDetails = await this.loadFormDetails(metadata.formId);
                  if (formDetails && formDetails.formMetadata) {
                    const formMetadata = JSON.parse(formDetails.formMetadata);
                    if (formMetadata.fields && Array.isArray(formMetadata.fields)) {
                      // Find date fields
                      formMetadata.fields.forEach(field => {
                        if (field.type === 'datetime' || field.type === 'date') {
                          dateFields.push({
                            value: `form-${metadata.formId}-${field.id}`,
                            text: `${formDetails.title || 'Form'} - ${field.title || 'Date Field'}`,
                            formId: metadata.formId,
                            fieldId: field.id,
                            fieldTitle: field.title
                          });
                        }
                      });
                    }
                  }
                }
              } catch (error) {
                console.error('Error parsing form metadata:', error);
              }
            }
          }
          
          // Add default SOP completion option
          dateFields.unshift({
            value: 'sop-completion',
            text: 'SOP Completion',
            formId: null,
            fieldId: null,
            fieldTitle: null
          });
          
          this.availableDateFields = dateFields;
          console.log('Available date fields:', dateFields);
          
        } catch (error) {
          console.error('Error extracting date fields:', error);
          // Fallback to default
          this.availableDateFields = [{
            value: 'sop-completion',
            text: 'SOP Completion',
            formId: null,
            fieldId: null,
            fieldTitle: null
          }];
        }
      },
      async loadFormDetails(formId) {
        try {
          const query = `
            query FormById($id: Int!) {
              formById(id: $id) {
                id
                title
                name
                formMetadata
                createdAt
                updatedAt
              }
            }
          `;

          const response = await TCVelikClient.PostRelative('/api/graphql', {
            query: query,
            variables: { id: parseInt(formId) }
          });

          if (response && response.data && response.data.data && response.data.data.formById) {
            return response.data.data.formById;
          }
        } catch (error) {
          console.error('Error loading form details:', error);
        }
        return null;
      },
      async loadAvailableSOPs() {
        try {
          const query = `
            query {
              onboardings {
                id
                name
                description
                created
                lastModified
              }
            }
          `;

          const response = await TCVelikClient.PostRelative('/api/graphql', {
            query: query
          });

          console.log('SOP loading response:', response);
          if (response && response.data && response.data.data && response.data.data.onboardings) {
            this.availableSOPs = response.data.data.onboardings;
            console.log('Available SOPs:', this.availableSOPs);
          } else {
            console.log('No onboardings found in response');
          }
        } catch (error) {
          console.error('Error loading SOPs:', error);
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to load SOPs',
            color: 'danger'
          });
        }
      },

      async loadAvailableUsers() {
        try {
          const query = `
            query Users($skip: Int, $take: Int, $search: String, $sortType: String, $sortOrder: String!) {
              users(skip: $skip, take: $take, search: $search, sortType: $sortType, sortOrder: $sortOrder) {
                totalCount
                result {
                  id
                  firstName
                  lastName
                  email
                  userName
                }
              }
            }
          `;

          const response = await TCVelikClient.PostRelative('/api/graphql', {
            query: query,
            variables: {
              skip: 0,
              take: 1000, // Get all users for the dropdown
              search: '',
              sortType: 'lld',
              sortOrder: 'desc'
            }
          });

          if (response && response.data && response.data.data && response.data.data.users && response.data.data.users.result) {
            this.availableUsers = response.data.data.users.result;
            console.log('Available users:', this.availableUsers);
          } else {
            console.log('No users found in response');
            this.availableUsers = [];
          }
        } catch (error) {
          console.error('Error loading users:', error);
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to load users',
            color: 'danger'
          });
          this.availableUsers = [];
        }
      },

      openSOPSelector() {
        this.showSOPSelector = true;
      },

      closeSOPSelector() {
        this.showSOPSelector = false;
      },

      selectSOP(sop) {
        this.assignSOPPropertiesData.selectedSOP = sop;
        this.assignSOPPropertiesData.sopId = sop.id;
        this.closeSOPSelector();
      },

      SaveAssignSOPPropertiesStep() {
        if (!this.isAssignSOPPropertiesFormValid) {
          this.$vs.notify({
            title: 'Validation Error',
            text: `Please fill in all required fields. SOP: ${this.assignSOPPropertiesData.selectedSOP ? 'Selected' : 'Not selected'}, UserId: ${this.assignSOPPropertiesData.userId}, DueDate: ${this.assignSOPPropertiesData.dueDate}`,
            color: 'danger'
          });
          return;
        }

        // Update the metadata in the step
        const metadata = JSON.stringify({
          sopId: this.assignSOPPropertiesData.sopId,
          userId: this.assignSOPPropertiesData.userId,
          dueDate: this.assignSOPPropertiesData.dueDate,
          dateType: this.assignSOPPropertiesData.dateType,
          relativeDays: this.assignSOPPropertiesData.relativeDays,
          relativeEvent: this.assignSOPPropertiesData.relativeEvent,
          selectedSOP: {
            id: this.assignSOPPropertiesData.selectedSOP.id,
            name: this.assignSOPPropertiesData.selectedSOP.name,
            description: this.assignSOPPropertiesData.selectedSOP.description
          },
          allowUserToChangeValues: this.assignSOPPropertiesData.allowUserToChangeValues
        });
        
        // Find the SOP title for display
        const selectedSOP = this.availableSOPs.find(s => s.id == this.assignSOPPropertiesData.sopId);
        const sopTitle = selectedSOP ? selectedSOP.name : 'Unknown SOP';
        
        // Find the selected user for display
        const selectedUser = this.availableUsers.find(u => u.id == this.assignSOPPropertiesData.userId);
        const userDisplayName = selectedUser ? `${selectedUser.firstName || ''} ${selectedUser.lastName || ''} (${selectedUser.email})` : 'Unknown User';
        
        // Update the step content
        const stepContent = this.stepNode.querySelector('.content');
        if (stepContent) {
          const titleElement = stepContent.querySelector('p:first-child');
          const sopIdElement = stepContent.querySelector('p:nth-child(2)');
          const metadataElement = stepContent.querySelector('p:nth-child(3)');
          
          if (titleElement) {
            titleElement.innerHTML = '<strong>Assign SOP</strong>';
          }
          if (sopIdElement) {
            let dueDateText = '';
            if (this.assignSOPPropertiesData.dateType === 'absolute') {
              dueDateText = `Due Date: ${this.assignSOPPropertiesData.dueDate}`;
            } else {
              dueDateText = `Due Date: ${this.assignSOPPropertiesData.relativeDays} days after ${this.assignSOPPropertiesData.relativeEvent}`;
            }
            
            sopIdElement.innerHTML = `SOP: ${sopTitle} (ID: ${this.assignSOPPropertiesData.sopId})<br>
                                     Assign To: ${userDisplayName}<br>
                                     ${dueDateText}<br>
                                     Allow User Changes: ${this.assignSOPPropertiesData.allowUserToChangeValues ? 'Yes' : 'No'}`;
          }
          if (metadataElement) {
            metadataElement.innerHTML = metadata;
          }
        }

        // Update the editor content
        this.editor.commands.setContent(this.editor.getHTML());

        // Reset form data
        this.assignSOPPropertiesData = {
          sopId: '',
          userId: '',
          dueDate: null,
          selectedSOP: null,
          allowUserToChangeValues: false,
          dateType: 'absolute',
          relativeDays: 5,
          relativeEvent: 'sop-completion'
        };

        // Close the popup
        this.IsInAssignSOPPropertiesMode = false;

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');

        this.$vs.notify({
          title: 'Success',
          text: 'SOP properties updated successfully',
          color: 'success'
        });
      },
      OpenCadenceMenu() {
        this.IsInOnboardingCadenceMode = true;
      },

      SaveHTML(value) {
        this.$emit("HtmlPaste", value);
        this.editor.commands.setContent(value);

        this.$vs.notify({
          title: this.$t('SavedChanges'),
          color: "success",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-check-circle",
        });

        this.IsInHTMLEditorMode = false;
      },

      SaveMetadata() {
        this.stepNode.querySelector('p:nth-of-type(3)').innerHTML = this.$refs.monacoEditor.getValue()
        this.editor.commands.setContent(this.editor.getHTML())
        this.$vs.notify({
          title: this.$t('SavedChanges'),
          color: "success",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-check-circle",
        });
      },

      SaveFreeHtmlChanges(value) {
        EventBus.$emit(`update_freeHtml_${this.freeHtmlElement}`, value)
      },

      SaveIntent(intent) {
        this.$emit("AddIntent", intent)
      },


      SaveCodeStepData(value) {
        var el = this.stepNode.querySelector('p:nth-of-type(3)')
        el.querySelectorAll("br").forEach(br => br.remove());
        var properties = el.innerHTML
        try {
          if (properties != null) {
            var json = JSON.parse(properties)
            json["Source"] = btoa(value)
            el.innerHTML = JSON.stringify(json)
          }
        }
        catch (error) {
          var obj = {
            Source: btoa(value)
          }
          el.innerHTML = JSON.stringify(obj)
        }
        this.stepNode = "";
      },

      ExtractMetadata(value) {
        var jsonObject = '';
        console.log("yes")
        if (typeof value === 'string' && this.editorMode == "Metadata") {
          try {
            const match = value.match(/\{([^}]+)\}/);
            jsonObject = JSON.parse(match[0]);

          } catch (e) {
            this.monacoCodeValue = ''
            return;
          }
        }
        else {
          return;
        }
        if (!jsonObject.hasOwnProperty('code')) {
          this.monacoCodeValue = ''
        }
        else {
          this.monacoCodeValue = jsonObject.code
        }
      },


      async uploadImage(base64Image, fileName) {
        var instance = this;
        TCVelikClient.PostRelative("/api/download/SaveImage", {
          ImageUrl: window.location.href, Base64: base64Image
        }).then(function (response) {
          if (response) {
            var data = response.data.Url
            var url = "/api/download/getfile?id=" + data.substr(data.length - 40);
            instance.InAddImageMode = false
            instance.imageUpload = null
            instance.AddImage(url)
          }
        }).catch(err => {
          instance.$vs.notify({
            title: this.$t('ProblemAddingImage'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        })

      },


      AddImage(url) {
        if (this.pendingImagePosition !== null) {
          // Insert image at the specific position
          this.editor.chain()
            .insertContentAt(this.pendingImagePosition, `<img src="${url}" alt="Image" />`)
            .focus("end")
            .run();
          this.pendingImagePosition = null;
        } else {
          // Default behavior - insert at cursor position
          this.editor.chain().focus().setImage({ src: url }).run();
        }
      },

      HideImageEditorIcon(which) {

        window.requestAnimationFrame(function () {
          var icon = which.target.parentElement.querySelector("button#edit-image");

          if (which.toElement != icon) {
            icon.style.display = "none";
            console.log("Hiding ...", which.target);
          }
        });
      },
      handlePaste(e) {
        return this.processClipboardItems(e.clipboardData);
      },

      processClipboardItems(clipboardData) {

        // Check for TCVelik format content first
        let hasTCVelikContent = false;
        var items = clipboardData.items;

        for (const item of items) {
          console.log('Processing item:', item.type, 'kind:', item.kind);
          if (item.type === 'text/html' || item.type === 'text/plain') {
            try {

              const content = clipboardData.getData(item.type) // getClipboardDataSync(item);
              console.log('Processing content type:', item.type, 'Length:', content?.length);
              console.log('Content preview:', content?.substring(0, 100));

              if (content && content.includes('data-type="draggable-item"')) {
                console.log('Found TCVelik content, processing...');
                // Parse the HTML to extract the draggable items
                const parser = new DOMParser();
                const doc = parser.parseFromString(content, 'text/html');
                const draggableItems = doc.querySelectorAll('[data-type="draggable-item"]');

                if (draggableItems.length > 0) {
                  console.log('Found TCVelik content, processing...');

                  // Convert the draggable items back to HTML string
                  let processedHtml = '';
                  draggableItems.forEach(item => {
                    processedHtml += item.outerHTML;
                  });

                  // Insert the HTML content at cursor position
                  this.editor.chain().focus()
                    .insertContent(processedHtml)
                    .run();

                  // Emit event to notify that steps have changed
                  EventBus.$emit('stepsChanged');

                  this.$vs.notify({
                    title: this.$t('TCVelikContentPasted'),
                    text: this.$t('StepsAddedSuccessfully', { count: draggableItems.length }),
                    color: "success",
                    iconPack: "feather",
                    position: "top-center",
                    icon: "icon-check-circle",
                  });

                  hasTCVelikContent = true;
                  break; // Exit the loop since we found TCVelik content
                }
              }
            } catch (error) {
              console.warn('Error processing clipboard text content:', error);
            }
          }
        }

        if (hasTCVelikContent) {
          return true;
        }

        // Handle images (only if no TCVelik content was found)
        for (const item of items) {
          if (item.type.indexOf('image') === 0) {
            try {
              const file = item.getAsFile();
              if (file) {
                const reader = new FileReader();

                reader.onload = (event) => {
                  this.editor.chain().focus()
                    .setImage({ src: event.target.result }).run();
                };

                reader.onerror = (error) => {
                  console.warn('Error reading image file:', error);
                };

                reader.readAsDataURL(file);
                return true; // Exit after handling the first image
              }
            } catch (error) {
              console.warn('Error processing clipboard image:', error);
              return false;
            }
          }
        }

        // If no TCVelik content or images found, handle as plain text
        return false;
      },
      Publish() {
        this.$emit('Publish');
      },
      SaveDraft() {
        this.$emit('SaveDraft');
      },
      RevisionHistory() {
        this.$emit("RevisionHistory");
      },
      HasImageChanges(isChanged) {
        this.IsImageChanged = isChanged;
      },
      AddManualStep(subtype) {
        if (subtype == 'camera') {
          this.OpenCameraStepMenu()
          return;
        }

        if (subtype == 'assign-sop') {
          this.OpenAssignSOPMenu()
          return;
        }

        if (subtype == 'form-capture') {
          this.OpenFormCaptureMenu()
          return;
        }

        stepUtility.AddManualStep(this.editor, subtype);

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');
      },

      CreateImageStep(img) {
        stepUtility.AddCameraStep(this.editor, img)
      },

      StepImageEdit(evt) {
        this.CurrentZoomImage = evt.srcElement.src;
        this.CurrentImgDOM = evt.srcElement;
        this.isImageEditorActive = true;
      },

      AddLineAbove() {
        const { $from } = this.editor.state.selection;

        const customNodePos = $from.node($from.depth - 1).type.name === 'draggableItem'
          ? $from.before($from.depth - 1)
          : null;

        if (customNodePos !== null) {
          this.editor.chain().focus().insertContentAt(customNodePos, '<p></p>').run();

          // Emit event to notify that steps have changed
          EventBus.$emit('stepsChanged');
        } else {
          this.$vs.notify({
            title: this.$t('CursorNotInsideCustomNode'),
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
      },

      AddLineBellow() {
        const { $from } = this.editor.state.selection;

        const customNodePos = $from.node($from.depth - 1).type.name === 'draggableItem'
          ? $from.after($from.depth - 1)
          : null;

        if (customNodePos !== null) {
          this.editor.chain().focus().insertContentAt(customNodePos, '<p></p>').run();

          // Emit event to notify that steps have changed
          EventBus.$emit('stepsChanged');
        } else {
          this.$vs.notify({
            title: this.$t('CursorNotInsideCustomNode'),
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
      },

      //handles custom html content insertion
      insertCustomHTML(htmlString) {
        var id = Math.random()
        this.editor.chain().focus().insertContent({
          type: 'freeHtmlElement',
          attrs: {
            html: htmlString || `<div class="custom"><button>Hello</button</div>`,
            fh_id: id
          },
        }).run()
      },

      ImportFile() {
        TCVelikExportImportService.triggerFileImport(this.$refs.import);
      },

      async ReadExportFile(event) {
        const result = await TCVelikExportImportService.handleFileInputChange(
          event,
          (data) => {
            this.$emit("UpdateTitleDescription", data.title, data.description);
            this.$emit("HtmlPaste", data.content);
          },
          (error) => {
            this.$vs.notify({
              title: "Import Error",
              text: error,
              color: "error",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-alert-circle",
            });
          },
          this.$refs.import
        );
      },

      async ExportForTCVelik() { 
        const editorContent = this.editor ? this.editor.getHTML() : '';
        
        const result = await TCVelikExportImportService.exportToTCVelik({
          title: this.title,
          description: this.description,
          htmlContent: editorContent,
          progressCallback: (progress) => {
            this.genericType = progress.type;
            this.genericProgressActive = progress.active;
            this.genericCurrentStep = progress.currentStep;
            this.genericTotalSteps = progress.totalSteps;
          }
        });

        if (!result.success) {
          console.error('Export failed:', result.error);
          this.$vs.notify({
            title: "Export failed",
            text: result.error,
            color: "error",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
        }
      },

      async ExportToPPTX() {
        var pptx = new pptxgen();
        var steps = Array.from(document.getElementsByClassName("draggable-item"));

        var first_slide = pptx.addSlide();

        first_slide.background = {
          color: '69029a'
        };



        first_slide.addText(this.title, {
          x: 1,
          y: 2,
          w: 8,
          h: 2,
          fontSize: 36,
          color: 'FFFFFF',
          bold: true,
          align: 'center',
          valign: 'middle'
        });


        first_slide.addText(this.description, {
          x: 1,
          y: 4,
          w: 8,
          h: 1.5,
          fontSize: 18,
          color: 'FFFFFF',
          bold: false,
          align: 'center',
          valign: 'top'
        });

        const convertToBase64 = async (url) => {
          const response = await fetch(url);
          const blob = await response.blob();
          return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        };

        for (var i = 0; i < steps.length; i++) {
          var slide = pptx.addSlide();


          slide.background = {
            color: '69029a'
          };

          var title = steps[i].getElementsByTagName('p')[0].innerText;
          var description = steps[i].getElementsByTagName('p')[1].innerText;
          var image = steps[i].getElementsByTagName('img')[0];


          slide.addText(title, {
            x: 1,
            y: 0.5,
            w: 8,
            h: 1,
            fontSize: 24,
            color: 'FFFFFF',
            bold: true,
            align: 'left'
          });


          slide.addText(description, {
            x: 1,
            y: 1,
            w: 8,
            h: 1,
            fontSize: 18,
            color: 'FFFFFF',
            bold: false,
            align: 'left'
          });

          if (image) {
            const img = new Image();
            img.src = image.src;
            await new Promise(resolve => img.onload = resolve);

            const naturalWidth = img.naturalWidth;
            const naturalHeight = img.naturalHeight;
            const aspectRatio = naturalWidth / naturalHeight;


            const maxWidth = 6;
            const maxHeight = 3;


            let width, height;

            if (aspectRatio > maxWidth / maxHeight) {

              width = maxWidth;
              height = maxWidth / aspectRatio;
            } else {

              height = maxHeight;
              width = maxHeight * aspectRatio;
            }

            const base64 = await convertToBase64(image.src);
            slide.addImage({
              data: base64,
              x: 2,
              y: 2,
              w: width,
              h: height
            });
          }
        }


        var copy_title = this.title;
        var pptx_title = copy_title.replace(/ /g, ""); // Replace ALL spaces, not just first one

        pptx.writeFile({ fileName: pptx_title })
          .then(fileName => {
            console.log(`created file: ${fileName}`);
          })
          .catch(error => {
            console.error('Error creating PPTX file:', error);
          });
      },

      async ExportSOPFormat() {
        // TODO: Implement SOP format export functionality
        console.log('Exporting in SOP format...');
        this.$vs.notify({
          title: this.$t('SOPFormatExport'),
          text: this.$t('SOPFormatExportComingSoon'),
          color: "primary",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-info",
        });
      },

      EmitRecordingChanged() {
        this.IsRecordingState = !this.IsRecordingState;
        this.$emit("RecordingChanged", this.IsRecordingState);

        var attachedWebView = chrome?.webview;
        if (attachedWebView) {
          attachedWebView.postMessage({
            type: "RecordingChange",
            value: this.IsRecordingState
          });
        }
      },
      GetEditorInsance() {
        return this.editor;
      },

      handleAddLink({ url, text }) {
        this.GetEditorInsance()
          .chain()
          .insertContent(`<p><a target="_blank" rel="noopener noreferrer nofollow" href="${url}">${text}</a></p>`)
          .focus("end")
          .run();

        this.InAddLinkMode = false;
      },

      ImageSaved(img) {
        var instance = this
        this.CurrentZoomImage = img;
        this.CurrentImgDOM.src = img;

        var imageUrl = this.CurrentImgDOM.dataset["url"];

        TCVelikClient.PostRelative("/api/download/SaveImage", {
          ImageUrl: imageUrl,
          Base64: img
        }).then(function () {
          instance.$vs.notify({
            title: this.$t('SuccessfullySavedImage'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });

          instance.IsImageChanged = false;
          instance.isImageEditorActive = false;
        });
      },
      CopyLink(monacoValue) {
        var instance = this;
        this.$copyText(monacoValue).then(
          function () {
            instance.$vs.notify({
              title: this.$t('SuccessExclamation'),
              text: this.$t('TextCopiedSuccessfully'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })
      },

      AskAiForIntent(aiData) {
        var instance = this;
        var documentCopy = document.cloneNode(true);
        var steps = documentCopy.getElementsByClassName("content");
        var result = [];

        Array.from(steps).forEach(step => {
          let paragraphs = step.getElementsByTagName("p");
          if (paragraphs.length >= 1) {
            // Get title from first paragraph (if it exists)
            let title = paragraphs[0]?.textContent?.trim() || '';

            // Get content from second paragraph (if it exists)
            let content = '';
            if (paragraphs.length >= 2) {
              let imgs = paragraphs[1].getElementsByTagName("img");
              Array.from(imgs).forEach(img => img.remove());
              content = paragraphs[1].textContent?.trim() || '';
            }

            // Get metadata from third paragraph (if it exists)
            let metadata = '';
            if (paragraphs.length >= 3) {
              metadata = paragraphs[2].textContent?.trim() || '';
            }

            if (metadata && metadata.length > 100) {
              console.log("Cutting data ", metadata);
              metadata = metadata.substring(0, 100);
            }

            // Only add to result if we have at least a title or content
            if (title || content) {
              result.push({
                Title: title,
                Description: content,
                Metadata: metadata
              });
            }
          }
        });

        // Build existing intents context for AI
        var existingIntentsContext = "";
        if (aiData && aiData.currentIntent) {
          existingIntentsContext = "\n\nEXISTING INTENT VALUES IN THE SYSTEM:\n" + JSON.stringify(aiData.currentIntent, null, 2) +
            "\n\nIMPORTANT: When possible, use values from the existing intents above. Only create new values if absolutely necessary and they don't match any existing ones.GENERATE VALUES FOR THE ADDITIONAL FIELDS(IF POSSIBLE)";
        }

        var payload = {
          InputTokens: 0,
          OutputTokens: 0,
          Messages: [
            {
              Role: "System",
              Content: "You must return the result as JAVASCRIPT OBJECT.DO NOT SPLIT THE VECTORS INTO A  SUB-OBJECT.THE VECTORS CAN HAVE MULTIPLE VALUES SO PUT THEM IN AN ARRAY.DO NOT ADD A 'json' STRING IN THE BEGINNING.YOU MUST NOT PUT THE RESULT IN A STRING.DO NOT PROVIDE EXTRA EXPLAINATIONS.You are helping categorize and infer intent from Standard Operating Procedures (SOPs) to improve discoverability, contextual relevance, and assistant suggestions.You must return the result as a JSON object.Given an SOP (including its title, description, steps, and optionally metadata), extract and assign the following vectors:\n Primary Vectors to Extract:System – What platform or tool is the SOP related to?(e.g., Sitefinity, Azure DevOps, Outlook, Power Automate, etc.)\nClient – Which organization or customer this SOP is specific to?(e.g., Eveliko, KAUST, Dubai Airports, or leave blank if generic, try to identify this from the metadata too)\nProject – Which project within the client it relates to, if applicable.(e.g Student Portal, SharePoint Migration, etc., again if links to the system or metadata is available - try to identify from there)\nRole – Who is expected to perform this SOP?(e.g., Developer, Editor, Compliance Officer, Admin, if none of those - find ideal role or leave blank if not specified)\nSecondary Vectors to Extract(if detectable):\nActionType– What is the user doing ?(e.g., Create, Edit, Approve, Deploy, Review, Submit, use metadata if any and also - propose other actions if not applicable)\nLifecycleStage– Where does this SOP fit in the bigger picture ?(e.g., Onboarding, Audit Prep, Release Planning, Support Response, propose if not in the list here)\n Technology – Granular tooling beyond the system(e.g., Azure Pipelines, Teams Chat, Graph API, Razor Views, propose if you know it and not in the list)\n Environment – Where is this performed ?(e.g., Production, QA, Dev, Local, Staging, try to identify this from the urls and metadata)\n Persona – What kind of person is this designed for?(e.g., Junior Developer, Project Manager, Trainee, propose others if not in the list)\n Frequency – How often is this done ?(e.g., One - time, Monthly, On Event, Daily Task, propose others if not in the list)\n SensitivityLevel – Does it involve confidential or regulated data(e.g., PII, Internal Only, IT Access Required, you MUST pick one here).\nArea - the area or module in question if the SOP is specific enough. E.g. Users, Flights, Lost and Found forms, Carousels, News module, etc" + existingIntentsContext
            },
            {
              Role: "User",
              Content: JSON.stringify({
                Title: this.title,
                Description: this.description,
                Steps: result
              })
            }]
        };

        var options = {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        };

        TCVelikClient.PostRelative("/api/OpenAI/ChatWithFunctions", payload, options).then(function (response) {
          if (response && response.data && response.data) {

            try {
              var newText = JSON.parse(response.data.Messages[response.data.Messages.length - 1].Content);
              instance.$emit("AddIntent", JSON.parse(newText[0].Text))

            }
            catch (err) {
              alert('Something happened...');
            }
          }
        });


      },

      changeHeadingDisplay(tagName) {
        if (this.$refs.headingValue) {
          this.$refs.headingValue.innerHTML = tagName.charAt(0) === 'H' ? tagName : 'P'
        }
      },
      formatDocument() {
        if (this.editor) {
          // Basic formatting example - you can customize this
          this.editor
            .chain()
            .focus()
            .selectAll()
            .normalize()
            .run();

          this.$vs.notify({
            title: this.$t('DocumentFormatted'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
      },
      handleAddStepFromNode(data) {
        const { position, node } = data;

        // Get the current selection to find the node position
        const { $from } = this.editor.state.selection;

        // Find the draggable item node position
        let nodePos = null;
        let nodeSize = 0;

        // Walk up the tree to find the draggable item
        for (let depth = $from.depth; depth >= 0; depth--) {
          const currentNode = $from.node(depth);
          if (currentNode.type.name === 'draggableItem') {
            nodePos = $from.start(depth);
            nodeSize = currentNode.nodeSize;
            break;
          }
        }

        // If we couldn't find a draggable item, try to find the closest one
        if (nodePos === null) {
          // Find all draggable items in the document
          const doc = this.editor.state.doc;
          let foundNode = null;
          let foundPos = null;

          doc.descendants((node, pos) => {
            if (node.type.name === 'draggableItem') {
              foundNode = node;
              foundPos = pos;
              return false; // Stop searching
            }
          });

          if (foundNode && foundPos !== null) {
            nodePos = foundPos;
            nodeSize = foundNode.nodeSize;
          } else {
            console.warn('Could not find any draggable item in the document');
            return;
          }
        }

        // Validate position is within document bounds
        const docSize = this.editor.state.doc.content.size;
        if (nodePos >= docSize) {
          console.warn('Calculated position is out of document bounds');
          return;
        }

        // Use the same approach as StepUtility.AddManualStep but with positioning
        const id = Math.random();
        const stepHtml = '<div data-type="draggable-item" data-temp-step-id=' + id + ' data-subtype="informational"><p><strong>Step</strong></p><p></p><p></p></div>';

        if (position === 'before') {
          // Add step before the current node
          this.editor.chain()
            .insertContentAt(nodePos, stepHtml)
            .focus("end")
            .run();
        } else {
          // Add step after the current node
          const afterPos = nodePos + nodeSize;
          if (afterPos <= docSize) {
            this.editor.chain()
              .insertContentAt(afterPos, stepHtml)
              .focus("end")
              .run();
          } else {
            // If after position is out of bounds, add at the end
            this.editor.chain()
              .insertContentAt(docSize, stepHtml)
              .focus("end")
              .run();
          }
        }

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');
      },
      handleAddLineFromNode(data) {
        const { position, node } = data;

        // Get the current selection to find the node position
        const { $from } = this.editor.state.selection;

        // Find the draggable item node position
        let nodePos = null;
        let nodeSize = 0;

        // Walk up the tree to find the draggable item
        for (let depth = $from.depth; depth >= 0; depth--) {
          const currentNode = $from.node(depth);
          if (currentNode.type.name === 'draggableItem') {
            nodePos = $from.start(depth);
            nodeSize = currentNode.nodeSize;
            break;
          }
        }

        // If we couldn't find a draggable item, try to find the closest one
        if (nodePos === null) {
          // Find all draggable items in the document
          const doc = this.editor.state.doc;
          let foundNode = null;
          let foundPos = null;

          doc.descendants((node, pos) => {
            if (node.type.name === 'draggableItem') {
              foundNode = node;
              foundPos = pos;
              return false; // Stop searching
            }
          });

          if (foundNode && foundPos !== null) {
            nodePos = foundPos;
            nodeSize = foundNode.nodeSize;
          } else {
            console.warn('Could not find any draggable item in the document');
            return;
          }
        }

        // Validate position is within document bounds
        const docSize = this.editor.state.doc.content.size;
        if (nodePos >= docSize) {
          console.warn('Calculated position is out of document bounds');
          return;
        }

        if (position === 'before') {
          // Add line before the current node
          this.editor.chain()
            .insertContentAt(nodePos, '<p></p>')
            .focus("end")
            .run();
        } else {
          // Add line after the current node
          const afterPos = nodePos + nodeSize;
          if (afterPos <= docSize) {
            this.editor.chain()
              .insertContentAt(afterPos, '<p></p>')
              .focus("end")
              .run();
          } else {
            // If after position is out of bounds, add at the end
            this.editor.chain()
              .insertContentAt(docSize, '<p></p>')
              .focus("end")
              .run();
          }
        }

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');
      },
      handleAddStepAtPosition(data) {
        const { position, subtype = 'informational' } = data;

        // Check if the editor is empty or has no proper content
        const docSize = this.editor.state.doc.content.size;
        const isEmpty = docSize <= 2; // Document node + empty paragraph

        if (isEmpty) {
          // If editor is empty, insert a paragraph first to create proper structure
          this.editor.chain()
            .insertContent('<p></p>')
            .run();
        }

        // Use the exact position provided by the divider
        // The divider is positioned at item.pos + item.node.nodeSize, which is correct
        const insertPosition = position;

        // Use the same approach as StepUtility.AddManualStep
        const id = Math.random();
        const stepHtml = `<div data-type="draggable-item" data-temp-step-id=${id} data-subtype="${subtype}"><p><strong>Step</strong></p><p></p><p></p></div>`;

        this.editor.chain()
          .insertContentAt(insertPosition, stepHtml)
          .focus("end")
          .run();

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');
      },
      handleAddLineAtPosition(data) {
        const { position } = data;

        // Check if the editor is empty or has no proper content
        const docSize = this.editor.state.doc.content.size;
        const isEmpty = docSize <= 2; // Document node + empty paragraph

        if (isEmpty) {
          // If editor is empty, just insert the paragraph directly
          this.editor.chain()
            .insertContent('<p></p>')
            .focus("end")
            .run();
        } else {
          // Use the exact position provided by the divider
          const insertPosition = position;

          this.editor.chain()
            .insertContentAt(insertPosition, '<p></p>')
            .focus("end")
            .run();
        }

        // Emit event to notify that steps have changed
        EventBus.$emit('stepsChanged');
      },
      handleAddImageAtPosition(data) {
        const { position } = data;

        // Check if the editor is empty or has no proper content
        const docSize = this.editor.state.doc.content.size;
        const isEmpty = docSize <= 2; // Document node + empty paragraph

        if (isEmpty) {
          // If editor is empty, insert a paragraph first to create proper structure
          this.editor.chain()
            .insertContent('<p></p>')
            .run();
        }

        // Use the exact position provided by the divider
        const insertPosition = position;

        // Open image upload dialog
        this.InAddImageMode = true;

        // Store the position for when image is uploaded
        this.pendingImagePosition = insertPosition;
      }
    },

    mounted() {

      EventBus.$on('metadataProvided', (element) => {
        var metadatawrapper = element.querySelector('.content p:nth-of-type(3)');
        var content = element.querySelector('.content');
        if (metadatawrapper == null) {
          metadatawrapper = document.createElement("p");
          content.appendChild(metadatawrapper);

        }
        this.stepNode = element;
        var metadata = metadatawrapper.innerHTML;
        this.OpenHTMLEditMenu(metadata, "Metadata");
      });

      EventBus.$on('codeStepCalled', (element) => {
        var source = ""
        var el = element.querySelector('.content p:nth-of-type(3)');
        el.querySelectorAll("br").forEach(br => br.remove());
        var properties = el.innerHTML
        this.stepNode = element;
        try {
          if (properties != null) {
            var json = JSON.parse(properties)
            if (json.hasOwnProperty("Source")) {
              source = atob(json["Source"])
            }
            else {
              source = ""
            }
          }
        }
        catch (error) {
          console.log("No propeties found.Defaulting to empty string.")
        }
        this.OpenCodeStepEditor(source);
      });

        EventBus.$on('formCapturePropertiesCalled', (element) => {
            var formId = ""
            var el = element.querySelector('.content p:nth-of-type(3)');
            el.querySelectorAll("br").forEach(br => br.remove());
            var properties = el.innerHTML
            this.stepNode = element;
            try {
                if (properties != null) {
                    var json = JSON.parse(properties)
                    if (json.hasOwnProperty("formId")) {
                        formId = json["formId"]
                    }
                    else {
                        formId = ""
                    }
                }
            }
            catch(error) {
               console.log("No properties found. Defaulting to empty string.")
            }
            this.OpenFormPropertiesEditor(formId);
        });

        EventBus.$on('assignSOPPropertiesCalled', (element) => {
            var sopId = ""
            var el = element.querySelector('.content p:nth-of-type(3)');
            el.querySelectorAll("br").forEach(br => br.remove());
            var properties = el.innerHTML
            this.stepNode = element;
            try {
                if (properties != null) {
                    var json = JSON.parse(properties)
                    if (json.hasOwnProperty("sopId")) {
                        sopId = json["sopId"]
                    }
                    else {
                        sopId = ""
                    }
                }
            }
            catch(error) {
               console.log("No properties found. Defaulting to empty string.")
            }
            this.OpenAssignSOPPropertiesEditor(sopId, properties);
        });

      // Listen for add step events
      EventBus.$on('addStep', (data) => {
        this.handleAddStepFromNode(data);
      });

      // Listen for add line events
      EventBus.$on('addLine', (data) => {
        this.handleAddLineFromNode(data);
      });

      // Listen for divider menu events
      EventBus.$on('addStepAtPosition', (data) => {
        this.handleAddStepAtPosition(data);
      });

      EventBus.$on('addFreeHtmlAtPosition', (data) => {
        this.insertCustomHTML();
      });

      EventBus.$on('freeHtmlEditCalled', (data) => {
        this.OpenFreeHtmlEditor(data);
      });

      EventBus.$on('addLineAtPosition', (data) => {
        this.handleAddLineAtPosition(data);
      });

      EventBus.$on('addImageAtPosition', (data) => {
        this.handleAddImageAtPosition(data);
      });


      EventBus.$on('saveAsStepTemplate', (data) => {
        this.OpenStepTemplateSave(data);
      });

      const ydoc = new Y.Doc();

      var instance = this;

      this.editor = new Editor({
        content: this.value,
        extensions: [
          TcvTableMenu,
          DisableEnter,
          FreeHtmlElement,
          DisableBackspace,
          ChromeNodeview,
          StarterKit.configure({
            clipboardTextSerializer: false, // Disable default clipboard handling
          }),
          Italic,
          Code,
          DividerMenuExtension,
          Table.configure({
            resizable: true,
          }),
          TableRow,
          TableHeader,
          TableCell,
          CustomTableCell,
          Image.configure({
            allowBase64: true,
            inline: true
          }),
          AIMenuExtension.configure({
            onAsk: ({ prompt, range, editor }) => {
              // Your AI handling logic here
            }
          }),
          BubbleMenu.configure({
            pluginKey: 'bubbleMenuOne',
            element: document.querySelector('.commands-button'),
            tippyOptions: {
            },
            shouldShow: ({ editor, view, state, oldState, from, to }) => {
              return true;
            },
          }),
          // Placeholder.configure({
          // }),
          Link.configure({
            openOnClick: false,
          }),
          Collaboration.configure({
            document: ydoc,
          }),
        ],
        onUpdate: ({ editor }) => {
          const html = editor.getHTML();
          if (html !== this.value) {
            this.$emit('input', html);
          }
        },

        editorProps: {
          handlePaste: function (view, event, slice) {
            return instance.handlePaste(event);
          }
        },
      });
      this.editor.on('selectionUpdate', ({ editor }) => {
        const { from } = editor.state.selection;
        const domElement = editor.view.domAtPos(from).node;
        if (domElement.tagName == undefined) {
          var name = domElement.parentElement.tagName
          if (name.charAt(0) == "P" || name.charAt(0) == "H") {
            this.changeHeadingDisplay(name);
          }
          else return;
        }
        else {
          this.changeHeadingDisplay(domElement.tagName);
        }
      })
    },

    beforeDestroy() {
      if (this.editor) {
        this.editor.destroy();
      }

      // Clean up event listeners
      EventBus.$off('metadataProvided');
      EventBus.$off('codeStepCalled');
      EventBus.$off('formCapturePropertiesCalled');
      EventBus.$off('assignSOPPropertiesCalled');
      EventBus.$off('addStep');
      EventBus.$off('addLine');
      EventBus.$off('addStepAtPosition');
      EventBus.$off('addLineAtPosition');
      EventBus.$off('addImageAtPosition');
    },
  };
</script>

<style lang="scss">
 .editor-container {
   position: relative;
   height: 100%;
   max-width: 1000px;
   margin: 0 auto;
   padding: 20px;
   background: white;
   font-family: 'Outfit', sans-serif;
   color: #0f172a;
   line-height: 1.6;
 }

 .menu-container {
   /*position: fixed;*/
   top: 80px;
   left: 260px;
   right: 0;
   z-index: 1000;
 }

 .toolbar-container {
   position: fixed;
   top: 128px;
   left: 260px;
           right: 0;
   z-index: 999;
 }

   .editor-content {
    background-color: white;
    padding: 20px;
    min-height: calc(100vh - 200px);
    border-radius: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 100px; /* Add space after editor content */
  }

 // Add some global styles for the editor container
     .editor-wrapper {
   padding-top: 48px; // Account for the fixed menu
 }

   @media (max-width: 768px) {
     .editor-container {
       padding: 10px !important;
       max-width: 100% !important;
       overflow-x: hidden !important;
     }
     
     .editor-content {
       padding: 10px;
       border-radius: 10px;
     }
   }

  /* Divider Menu Styles */
  .divider-menu {
    position: relative;
    height: 20px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  /*.divider-menu:hover {
    height: 30px;
  }*/

  .divider-line {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e0e0e0;
    transform: translateY(-50%);
    transition: all 0.2s ease;
  }

  /*.divider-menu:hover .divider-line {
    background: #007bff;
    height: 2px;
  }*/

  .divider-button {
    position: relative;
    width: 24px;
    height: 24px;
    background: #007bff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    opacity: 1; /* Always visible */
    transform: scale(1); /* Always at full size */
  }

  .divider-menu {
    margin-top: 50px; /* Add 50px spacing from content */
  }

  .divider-button:hover {
    background: #0056b3;
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .plus-icon {
    color: white;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
  }

  /* Step Styling from OnboardingPDF */
  [data-type='draggable-item'] {
    background: white;
    /*border-radius: 12px;*/
    transition: all 0.3s ease;
    margin-bottom: 1em;
    margin-top: 1em;
    /*box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);*/
    /*border: 1px solid #e0e0e0;*/
  }

  [data-type='draggable-item']:hover {
    /*box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);*/
  }

 /* [data-subtype='informational'] {
    border-left: 4px solid rgba(var(--vs-info), 1);
  }*/

/*  [data-subtype='warning'] {
    border-left: 4px solid rgba(var(--vs-warning), 1);
  }

  [data-subtype='success'] {
    border-left: 4px solid rgba(var(--vs-success), 1);
  }

  [data-subtype='error'] {
    border-left: 4px solid rgba(var(--vs-error), 1);
  }

  [data-subtype='code'] {
    border-left: 4px solid #6c757d;
  }

  [data-subtype='assign-sop'] {
    border-left: 4px solid #9c27b0;
  }

  [data-subtype='form-capture'] {
    border-left: 4px solid #ff9800;
  }*/

  /* Assign SOP Form Styling */
  .assign-sop-form {
    padding: 20px;
  }

  .assign-sop-form .vx-row {
    margin-bottom: 10px;
  }

  .assign-sop-form .text-right {
    text-align: right;
  }

  .assign-sop-form .ml-2 {
    margin-left: 8px;
  }

  /* Form Capture Form Styling */
  .form-capture-form {
    padding: 20px;
  }
  .form-capture-form .vx-row {
    margin-bottom: 10px;
  }
  .form-capture-form .text-right {
    text-align: right;
  }
  .form-capture-form .ml-2 {
    margin-left: 8px;
  }

  /* Form Properties Form Styling */
  .form-properties-form {
    padding: 20px;
  }
  .form-properties-form .vx-row {
    margin-bottom: 10px;
  }
  .form-properties-form .text-right {
    text-align: right;
  }
  .form-properties-form .ml-2 {
    margin-left: 8px;
  }

  /* Assign SOP Properties Form Styling */
  .assign-sop-properties-form {
    padding: 20px;
  }
  .assign-sop-properties-form .vx-row {
    margin-bottom: 10px;
  }
  .assign-sop-properties-form .text-right {
    text-align: right;
  }
  .assign-sop-properties-form .ml-2 {
    margin-left: 8px;
  }

  /* Step content styling */
  [data-type='draggable-item'] p:first-child {
    display: flex;
    align-items: center;
    padding: 10px 10px 10px 10px;
    cursor: pointer;
    gap: 16px;
    flex-grow: 1;
    font-weight: 700;
    font-size: 1.1em;
    margin: 0;
    color: #0f172a;
    border-bottom: 1px solid #f1f5f9;
  }

  [data-step-template] {
    border: solid;
    border-radius: 50px;
    border-color: lightgrey;
    padding: 10px;
    border-width: 2px;
  }

  [data-type='draggable-item'] p:nth-child(2) {
    display: block;
    font-size: 1em;
    padding: 20px;
    background: white;
    color: #0f172a;
    margin: 0;
    line-height: 1.6;
  }

  /* Mobile responsiveness for divider menu */
  @media (max-width: 768px) {
    .divider-menu {
      height: 15px;
      margin: 5px 0;
    }
    
    .divider-menu:hover {
      height: 20px;
    }
    
    .divider-button {
      width: 20px;
      height: 20px;
    }
    
    .plus-icon {
      font-size: 14px;
    }
    
    [data-type='draggable-item'] {
      margin: 10px 0;
      border-radius: 8px;
    }
    
    [data-type='draggable-item'] p:first-child {
      padding: 12px 16px;
      font-size: 1em;
    }
    
    [data-type='draggable-item'] p:nth-child(2) {
      padding: 16px;
    }
  }

  /* SOP Selection Styles */
  .sop-selection {
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 1rem;
    background-color: #f9fafb;
  }

  .no-sop-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .no-sop-text {
    color: #6b7280;
    font-style: italic;
  }

  .sop-selected {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
  }

  .sop-info {
    flex: 1;
  }

  .sop-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 0.5rem 0;
  }

  .sop-description {
    color: #6b7280;
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.4;
  }

  .change-link {
    color: #3b82f6;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    white-space: nowrap;
  }

  .change-link:hover {
    color: #1d4ed8;
    text-decoration: underline;
  }

  /* SOP Selector Modal Styles */
  .sop-selector-content {
    padding: 1rem;
    height: 100%;
    overflow-y: auto;
  }

  .sop-list-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .sop-list-header {
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 1rem;
  }

  .sop-table-container {
    flex: 1;
    overflow: auto;
  }

  .sop-table {
    margin: 0;
  }

  .sop-table .vs-table--tbody .vs-table--tr {
    border-bottom: 1px solid #f3f4f6;
  }

  .sop-table .vs-table--tbody .vs-table--tr:hover {
    background-color: #f9fafb;
  }

  .sop-table .vs-table--thead .vs-table--th {
    background-color: #f8fafc;
    font-weight: 600;
    color: #374151;
    border-bottom: 2px solid #e5e7eb;
  }

  .sop-id {
    font-weight: 500;
    color: #6b7280;
  }

  .sop-name strong {
    color: #1f2937;
  }

  .sop-description {
    color: #6b7280;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .empty-sops {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Date type selection styles */
  .date-type-selection {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.75rem;
  }

  .radio-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
    color: #374151;
  }

  .radio-option input[type="radio"] {
    margin: 0;
    cursor: pointer;
  }

  .relative-date-input {
    margin-top: 0.5rem;
  }

  .relative-text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 0.875rem;
    color: #6b7280;
    font-weight: 500;
  }

  .modal-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
  }

  /* Form field styles */
  .form-field {
    margin-bottom: 1rem;
  }

  .field-label {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
  }

  .field-input {
    width: 100%;
  }

  .checkbox-field {
    margin-top: 0.5rem;
  }
</style>

